import { ORGANIZATION_STORAGE_KEY, ORGANIZATION_DEFAULT, ORGANIZATION_NAME_STORAGE_KEY } from './constants'

export const getSelectedOrganization = () => {
  try {
    const org = window.localStorage.getItem(ORGANIZATION_STORAGE_KEY)
    if (org) {
      return org
    }
    throw new Error('No organization in local storage')
  } catch (e) {
    console.error(e, 'Failed to get selected organization from local storage, using default now')
    return ORGANIZATION_DEFAULT
  }
}

export const getSelectedOrganizationName = () => window.localStorage.getItem(ORGANIZATION_NAME_STORAGE_KEY) ?? getSelectedOrganization()

export const setSelectedOrganization = (organization: string) => window.localStorage.setItem(ORGANIZATION_STORAGE_KEY, organization)
